import * as yup from 'yup';

export const CANADIAN_AREA_CODES = [
  '204',
  '226',
  '236',
  '249',
  '250',
  '263',
  '289',
  '306',
  '343',
  '354',
  '365',
  '368',
  '382',
  '387',
  '403',
  '416',
  '418',
  '431',
  '437',
  '438',
  '450',
  '468',
  '474',
  '506',
  '514',
  '519',
  '548',
  '579',
  '581',
  '584',
  '587',
  '604',
  '613',
  '639',
  '647',
  '672',
  '705',
  '709',
  '742',
  '778',
  '780',
  '807',
  '819',
  '825',
  '867',
  '873',
  '902',
  '905',
  '942',
];

export const US_AREA_CODES = [
  // Alabama
  '205',
  '251',
  '256',
  '334',
  '659',
  '938',
  // Alaska
  '907',
  // Arizona
  '480',
  '520',
  '602',
  '623',
  '928',
  // Arkansas
  '327',
  '479',
  '501',
  '870',
  // California
  '209',
  '213',
  '279',
  '310',
  '323',
  '341',
  '350',
  '369',
  '408',
  '415',
  '424',
  '442',
  '510',
  '530',
  '559',
  '562',
  '619',
  '626',
  '628',
  '650',
  '657',
  '661',
  '669',
  '707',
  '714',
  '747',
  '760',
  '805',
  '818',
  '820',
  '831',
  '840',
  '858',
  '909',
  '916',
  '925',
  '949',
  '951',
  // Colorado
  '303',
  '719',
  '720',
  '970',
  '983',
  // Connecticut
  '203',
  '475',
  '860',
  '959',
  // Delaware
  '302',
  // District of Columbia (Washington DC)
  '202',
  '771',
  // Florida
  '239',
  '305',
  '321',
  '352',
  '386',
  '407',
  '561',
  '656',
  '727',
  '754',
  '772',
  '786',
  '813',
  '850',
  '863',
  '904',
  '941',
  '954',
  // Georgia
  '229',
  '404',
  '470',
  '478',
  '678',
  '706',
  '762',
  '770',
  '912',
  '943',
  // Hawaii
  '808',
  // Idaho
  '208',
  '986',
  // Illinois
  '217',
  '224',
  '309',
  '312',
  '331',
  '447',
  '464',
  '618',
  '630',
  '708',
  '773',
  '815',
  '847',
  '872',
  // Indiana
  '219',
  '260',
  '317',
  '463',
  '574',
  '765',
  '812',
  '930',
  // Iowa
  '319',
  '515',
  '563',
  '641',
  '712',
  // Kansas
  '316',
  '620',
  '785',
  '913',
  // Kentucky
  '270',
  '364',
  '502',
  '606',
  '859',
  // Louisiana
  '225',
  '318',
  '337',
  '504',
  '985',
  // Maine
  '207',
  // Maryland
  '240',
  '301',
  '410',
  '443',
  '667',
  // Massachusetts
  '339',
  '413',
  '508',
  '617',
  '774',
  '781',
  '857',
  '978',
  // Michigan
  '231',
  '248',
  '269',
  '313',
  '517',
  '586',
  '616',
  '734',
  '810',
  '906',
  '947',
  '989',
  // Minnesota
  '218',
  '320',
  '507',
  '612',
  '651',
  '763',
  '952',
  // Mississippi
  '228',
  '601',
  '662',
  '769',
  // Missouri
  '314',
  '417',
  '557',
  '573',
  '636',
  '660',
  '816',
  '975',
  // Montana
  '406',
  // Nebraska
  '308',
  '402',
  '531',
  // Nevada
  '702',
  '725',
  '775',
  // New Hampshire
  '603',
  // New Jersey
  '201',
  '551',
  '609',
  '640',
  '732',
  '848',
  '856',
  '862',
  '908',
  '973',
  // New Mexico
  '505',
  '575',
  // New York
  '212',
  '315',
  '332',
  '347',
  '516',
  '518',
  '585',
  '607',
  '631',
  '646',
  '680',
  '716',
  '718',
  '838',
  '845',
  '914',
  '917',
  '929',
  '934',
  // North Carolina
  '252',
  '336',
  '704',
  '743',
  '828',
  '910',
  '919',
  '980',
  '984',
  // North Dakota
  '701',
  // Ohio
  '216',
  '220',
  '234',
  '326',
  '330',
  '419',
  '440',
  '513',
  '567',
  '614',
  '740',
  '937',
  // Oklahoma
  '405',
  '539',
  '580',
  '918',
  // Oregon
  '458',
  '503',
  '541',
  '971',
  // Pennsylvania
  '215',
  '223',
  '267',
  '272',
  '412',
  '484',
  '570',
  '610',
  '717',
  '724',
  '814',
  '878',
  // Rhode Island
  '401',
  // South Carolina
  '803',
  '839',
  '843',
  '854',
  '864',
  // South Dakota
  '605',
  // Tennessee
  '423',
  '615',
  '629',
  '731',
  '865',
  '901',
  '931',
  // Texas
  '210',
  '214',
  '254',
  '281',
  '325',
  '346',
  '361',
  '409',
  '430',
  '432',
  '469',
  '512',
  '682',
  '713',
  '726',
  '737',
  '806',
  '817',
  '830',
  '832',
  '903',
  '915',
  '936',
  '940',
  '956',
  '972',
  '979',
  // Utah
  '385',
  '435',
  '801',
  // Vermont
  '802',
  // Virginia
  '276',
  '434',
  '540',
  '571',
  '703',
  '757',
  '804',
  '948',
  // Washington
  '206',
  '253',
  '360',
  '425',
  '509',
  '564',
  // West Virginia
  '304',
  '681',
  // Wisconsin
  '262',
  '414',
  '534',
  '608',
  '715',
  '920',
  // Wyoming
  '307',
];

export const NORTH_AMERICAN_AREA_CODES = [
  ...CANADIAN_AREA_CODES,
  ...US_AREA_CODES,
];

export const personalInfoSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters')
    .max(50, 'First name must be at most 50 characters')
    .matches(
      /^[a-zA-Z\s'-]+$/,
      'First name can only contain letters, spaces, hyphens, and apostrophes'
    ),

  lastName: yup
    .string()
    .required('Last name is required')
    .min(2, 'Last name must be at least 2 characters')
    .max(50, 'Last name must be at most 50 characters')
    .matches(
      /^[a-zA-Z\s'-]+$/,
      'Last name can only contain letters, spaces, hyphens, and apostrophes'
    ),

  email: yup.string().email('Invalid email').required('Email is required'),

  phone: yup
    .string()
    .required('Contact Number is required')
    // 1. Transform the input: If they didn't type +1, add it automatically
    .transform((value) => {
      if (!value) return value;

      // Remove any spaces or dashes the user might have typed
      const cleanValue = value.replace(/[\s-]/g, '');

      // If it starts with a 10-digit number (e.g., 4165551234), prepend '+1'
      if (/^\d{10}$/.test(cleanValue)) {
        return `+1${cleanValue}`;
      }
      // If it starts with '1' and has 11 digits total (e.g., 14165551234), prepend '+'
      if (/^1\d{10}$/.test(cleanValue)) {
        return `+${cleanValue}`;
      }

      return cleanValue;
    })
    // 2. Strict regex check: Ensure it is exactly '+1' followed by 10 digits
    .matches(
      /^\+1\d{10}$/,
      'Invalid contact number format. Must be a valid 10-digit number.'
    )
    // 3. Area Code Validation
    .test(
      'is-valid-nanp-area-code',
      'Invalid Canadian or US area code.',
      function (value) {
        if (!value) return true;

        // Because of our transform step, the value here is GUARANTEED to be "+1XXXXXXXXXX"
        const areaCode = value.substring(2, 5);

        // Check if it belongs to your allowed list
        return NORTH_AMERICAN_AREA_CODES.includes(areaCode);
      }
    ),

  address: yup.object().shape({
    street: yup
      .string()
      .required('Street  is required')
      .min(2, 'Street name must be at least 2 characters')
      .max(50, 'Street name must be at most 50 characters'),
    city: yup
      .string()
      .required('City is required')
      .min(2, 'City must be at least 2 characters')
      .max(20, 'City must be at most 20 characters')
      .matches(/^[a-zA-Z\s]*$/, 'City must contain only letters and spaces'),
    state: yup
      .string()
      .required('State address is required')
      .min(2, 'State name must be at least 2 characters')
      .max(50, 'State name must be at most 50 characters')
      .matches(
        /^[a-zA-Z\s]*$/,
        'State name must contain only letters and spaces'
      ),
    // Inside personalInfoSchema...
    postalCode: yup
      .string()
      .required('Postal code is required')
      .matches(
        /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i,
        'Postal code must be valid'
      ),
  }),

  bookingNotes: yup
    .string()
    .max(250, 'Notes must be at most 250 characters')
    .optional()
    .nullable(),

  dateOfBirth: yup
    .string()
    .optional()
    .nullable()
    .test('is-18', 'You must be at least 18 years old', (value) => {
      if (!value) return true;
      const dob = new Date(value);
      if (isNaN(dob.getTime())) return false;
      const today = new Date();
      if (dob > today) return false;
      const eighteenthBirthday = new Date(dob);
      eighteenthBirthday.setFullYear(dob.getFullYear() + 18);
      return eighteenthBirthday <= today;
    }),
});
